import * as ACTION_TYPES from './types';

const updateList = (list, item) => list.map(i => (i.id === item.id ? item : i));

const removeDoctorDuplicateId = list => {
  const results = {};
  list.forEach(i => {
    results[i.id] = i;
  });
  return Object.values(results);
};

const initialState = {
  status: {
    loadFellow: -1,
    loadList: -1,
    loadProfile: -1,
    updateProfile: -1,
    updateInfo: -1,
    payout: -1,
    updateColleges: -1,
    updateProfessions: -1,
    updateQualifications: -1,
    specialist: -1,
    speciality: -1,
    loadWorkExperiences: -1,
    createWorkExperience: -1,
    updateWorkExperience: -1,
    deleteWorkExperience: -1,
    uploadCompanyImage: -1,
    recents: -1,
  },
  list: [],
  fellows: [],
  recents: [],
  networkListLength: 0,
  profile: null,
  payout: null,
  titles: [],
  speciality: [],
  specialist: [],
  uploadCompanyImage: {},
  error: null,
  meta: {},
};

function reducer(state = initialState, action) {
  const { type, payload, error, meta } = action;

  switch (type) {
    case ACTION_TYPES.DOCTORS_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 0,
        },
        meta: null,
        list: [],
      };
    case ACTION_TYPES.DOCTORS_GET_SUCCEED: {
      const { isLoadMore } = meta;
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 1,
        },
        list: isLoadMore
          ? removeDoctorDuplicateId([...state.list, ...payload.data])
          : removeDoctorDuplicateId(payload.data),
        networkListLength: payload.data.length,
        meta: payload.meta,
      };
    }
    case ACTION_TYPES.DOCTORS_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 2,
        },
        error,
      };

    case ACTION_TYPES.FELLOW_DOCTORS_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadFellow: 0,
        },
        meta: null,
        fellows: [],
      };
    case ACTION_TYPES.FELLOW_DOCTORS_GET_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          loadFellow: 1,
        },
        fellows: payload.data,
        meta: payload.meta,
      };
    }
    case ACTION_TYPES.FELLOW_DOCTORS_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadFellow: 2,
        },
        error,
      };

    case ACTION_TYPES.DOCTOR_GET_PROFILE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadProfile: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_GET_PROFILE_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          loadProfile: 1,
        },
        profile: payload.data,
      };
    }
    case ACTION_TYPES.DOCTOR_GET_PROFILE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadProfile: 2,
        },
        error,
      };
    case ACTION_TYPES.DOCTOR_GET_PAYOUT_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          payout: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_GET_PAYOUT_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          payout: 1,
        },
        payout: payload.data,
      };
    }
    case ACTION_TYPES.DOCTOR_GET_PAYOUT_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          payout: 2,
        },
        error,
      };
    case ACTION_TYPES.DOCTOR_UPDATE_PROFILE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateProfile: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_UPDATE_PROFILE_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          updateProfile: 1,
        },
        profile: payload.data,
      };
    }
    case ACTION_TYPES.DOCTOR_UPDATE_PROFILE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateProfile: 2,
        },
        error,
      };
    case ACTION_TYPES.DOCTOR_UPDATE_INFO_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateInfo: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_UPDATE_INFO_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          updateInfo: 1,
        },
        profile: payload.data,
      };
    }
    case ACTION_TYPES.DOCTOR_UPDATE_INFO_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateInfo: 2,
        },
        error,
      };

    case ACTION_TYPES.DOCTOR_UPDATE_COLLEGES_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateColleges: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_UPDATE_COLLEGES_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          updateColleges: 1,
        },
        profile: {
          ...state.profile,
          colleges: payload.data,
        },
      };
    }
    case ACTION_TYPES.DOCTOR_UPDATE_COLLEGES_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateColleges: 2,
        },
        error,
      };

    case ACTION_TYPES.DOCTOR_UPDATE_QUALIFICATIONS_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateQualifications: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_UPDATE_QUALIFICATIONS_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          updateQualifications: 1,
        },
        profile: {
          ...state.profile,
          qualifications: payload.data,
        },
      };
    }
    case ACTION_TYPES.DOCTOR_UPDATE_QUALIFICATIONS_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateQualifications: 2,
        },
        error,
      };

    case ACTION_TYPES.DOCTOR_TITLE_GET_SUCCEED: {
      return {
        ...state,
        titles: payload.data,
      };
    }

    case ACTION_TYPES.DOCTORS_GET_SPECIALTIES_SUCCEED: {
      return {
        ...state,
        specialties: payload.data,
      };
    }
    case ACTION_TYPES.DOCTOR_SIGNATURE_SUCCEED:
    case ACTION_TYPES.DOCTOR_FINISH_INIT_SUCCEED:
    case ACTION_TYPES.DOCTOR_CURRENCY_SUCCEED: {
      return {
        ...state,
        profile: payload.data,
      };
    }

    case ACTION_TYPES.DOCTOR_UPDATE_QUALIFICATION_SUCCEED: {
      const newQualification = payload.data;
      return {
        ...state,
        profile: {
          ...state.profile,
          qualifications: updateList(state.profile.qualifications, newQualification),
        },
      };
    }
    case ACTION_TYPES.DOCTOR_ADD_QUALIFICATION_SUCCEED: {
      const newQualification = payload.data;
      return {
        ...state,
        profile: {
          ...state.profile,
          qualifications: [...state.profile.qualifications, newQualification],
        },
      };
    }
    case ACTION_TYPES.DOCTOR_DELETE_QUALIFICATION_SUCCEED: {
      return {
        ...state,
        profile: {
          ...state.profile,
          qualifications: state.profile.qualifications.filter(i => i.id !== meta.id),
        },
      };
    }

    case ACTION_TYPES.DOCTOR_UPDATE_COLLEGE_SUCCEED: {
      return {
        ...state,
        profile: {
          ...state.profile,
          colleges: updateList(state.profile.colleges, payload.data),
        },
      };
    }
    case ACTION_TYPES.DOCTOR_ADD_COLLEGE_SUCCEED: {
      return {
        ...state,
        profile: {
          ...state.profile,
          colleges: [...state.profile.colleges, payload.data],
        },
      };
    }
    case ACTION_TYPES.DOCTOR_DELETE_COLLEGE_SUCCEED: {
      return {
        ...state,
        profile: {
          ...state.profile,
          colleges: state.profile.colleges.filter(i => i.id !== meta.id),
        },
      };
    }

    case ACTION_TYPES.DOCTOR_UPDATE_PROFESSION_SUCCEED: {
      return {
        ...state,
        profile: {
          ...state.profile,
          professions: updateList(state.profile.professions, payload.data),
        },
      };
    }
    case ACTION_TYPES.DOCTOR_ADD_PROFESSION_SUCCEED: {
      return {
        ...state,
        profile: {
          ...state.profile,
          professions: [...state.profile.professions, payload.data],
        },
      };
    }
    case ACTION_TYPES.DOCTOR_DELETE_PROFESSION_SUCCEED: {
      return {
        ...state,
        profile: {
          ...state.profile,
          professions: state.profile.professions.filter(i => i.id !== meta.id),
        },
      };
    }

    case ACTION_TYPES.GET_SPECIALIST_REQUESTED: {
      return {
        ...state,
        specialist: [],
        status: {
          ...state.status,
          specialist: 0,
        },
        error: {
          ...state.error,
          specialist: null,
        },
      };
    }
    case ACTION_TYPES.GET_SPECIALIST_SUCCEED: {
      return {
        ...state,
        specialist: payload.data,
        status: {
          ...state.status,
          specialist: 1,
        },
        error: {
          ...state.error,
          specialist: null,
        },
      };
    }
    case ACTION_TYPES.GET_SPECIALIST_FAILED: {
      return {
        ...state,
        specialist: [],
        status: {
          ...state.status,
          specialist: 2,
        },
        error: {
          ...state.error,
          specialist: error,
        },
      };
    }

    case ACTION_TYPES.GET_SPECIALITY_REQUESTED: {
      return {
        ...state,
        speciality: [],
        status: {
          ...state.status,
          speciality: 0,
        },
        error: {
          ...state.error,
          speciality: null,
        },
      };
    }
    case ACTION_TYPES.GET_SPECIALITY_SUCCEED: {
      return {
        ...state,
        speciality: payload.data,
        status: {
          ...state.status,
          speciality: 1,
        },
        error: {
          ...state.error,
          speciality: null,
        },
      };
    }
    case ACTION_TYPES.GET_SPECIALITY_FAILED: {
      return {
        ...state,
        speciality: [],
        status: {
          ...state.status,
          speciality: 2,
        },
        error: {
          ...state.error,
          speciality: error,
        },
      };
    }

    case ACTION_TYPES.GET_WORK_EXPERIENCES_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadWorkExperiences: 0,
        },
      };
    case ACTION_TYPES.GET_WORK_EXPERIENCES_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          loadWorkExperiences: 1,
        },
        profile: { ...state.profile, workExperiences: payload.data },
      };
    }
    case ACTION_TYPES.GET_WORK_EXPERIENCES_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadWorkExperiences: 2,
        },
        error: {
          ...state.error,
          workExperiences: error,
        },
      };

    case ACTION_TYPES.CREATE_WORK_EXPERIENCE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          createWorkExperience: 0,
        },
      };
    case ACTION_TYPES.CREATE_WORK_EXPERIENCE_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          createWorkExperience: 1,
        },
        profile: {
          ...state.profile,
          workExperiences: [...(state.profile.workExperiences || []), payload.data],
        },
      };
    }
    case ACTION_TYPES.CREATE_WORK_EXPERIENCE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          createWorkExperience: 2,
        },
        error: {
          ...state.error,
          createWorkExperience: error,
        },
      };

    case ACTION_TYPES.UPDATE_WORK_EXPERIENCE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateWorkExperience: 0,
        },
      };
    case ACTION_TYPES.UPDATE_WORK_EXPERIENCE_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          updateWorkExperience: 1,
        },
        profile: {
          ...state.profile,
          workExperiences: state.profile.workExperiences.map(item => {
            return item.id === meta.id ? payload.data : item;
          }),
        },
      };
    }
    case ACTION_TYPES.UPDATE_WORK_EXPERIENCE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateWorkExperience: 2,
        },
        error: {
          ...state.error,
          updateWorkExperience: error,
        },
      };

    case ACTION_TYPES.DELETE_WORK_EXPERIENCE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          deleteWorkExperience: 0,
        },
      };
    case ACTION_TYPES.DELETE_WORK_EXPERIENCE_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          deleteWorkExperience: 1,
        },
      };
    }
    case ACTION_TYPES.DELETE_WORK_EXPERIENCE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          deleteWorkExperience: 2,
        },
        error: {
          ...state.error,
          deleteWorkExperience: error,
        },
      };

    case ACTION_TYPES.DOCTOR_UPDATE_PROFESSIONS_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateProfessions: 0,
        },
      };
    case ACTION_TYPES.DOCTOR_UPDATE_PROFESSIONS_SUCCEED: {
      return {
        ...state,
        profile: {
          ...state.profile,
          professions: payload.data,
        },
        status: {
          ...state.status,
          updateProfessions: 1,
        },
      };
    }
    case ACTION_TYPES.DOCTOR_UPDATE_PROFESSIONS_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateProfessions: 2,
        },
        error: {
          ...state.error,
          updateProfessions: error,
        },
      };

    case ACTION_TYPES.DOCTORS_GET_RECENT_REQUESTED:
      return {
        ...state,
        recents: [],
        status: {
          ...state.status,
          recents: 0,
        },
      };
    case ACTION_TYPES.DOCTORS_GET_RECENT_SUCCEED: {
      return {
        ...state,
        recents: payload.data,
        status: {
          ...state.status,
          recents: 1,
        },
      };
    }
    case ACTION_TYPES.DOCTORS_GET_RECENT_FAILED:
      return {
        ...state,
        recents: [],
        status: {
          ...state.status,
          recents: 2,
        },
        error: {
          ...state.error,
          recents: error,
        },
      };

    case ACTION_TYPES.DOCTORS_RESET_STATE:
      return initialState;

    case ACTION_TYPES.DOCTORS_RESET_ERRORS:
      return { ...state, error: null };
    default:
      return state;
  }
}

export default reducer;
